// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2p1Wf{color:#5e6e97;font-size:12px;font-size:1.2rem;line-height:20px;line-height:2rem}._3dHW4{background:#fff;padding:1.6rem}._2ykTI{list-style:none}._3ZhPt{border-top:1px solid #e0e8f2;margin-top:1.6rem}._3ZhPt:first-child{border-top:none;margin-top:0}._2zgUj{display:-ms-flexbox;display:flex;height:76px;height:7.6rem;padding:.4rem;width:76px;width:7.6rem;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;background-color:#fff;border:1px solid #e0e8f2;border-radius:8px}._2Nt5e{background:#eef7ff;border-radius:16px;padding:8px}._2Nt5e p.form-info{color:#5d748c;-ms-flex:none;flex:none;font-size:14px;font-weight:400;line-height:24px;margin:0;padding:0;-ms-flex-order:2;order:2;-ms-flex-item-align:stretch;align-self:stretch;-ms-flex-positive:0;flex-grow:0}", ""]);
// Exports
exports.locals = {
	"registrationPrivacy": "_2p1Wf",
	"container": "_3dHW4",
	"identities": "_2ykTI",
	"identity": "_3ZhPt",
	"identity__img": "_2zgUj",
	"guardianConsentsEmail": "_2Nt5e"
};
module.exports = exports;
